import { Link } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

import { ChainCardRef } from "../ValueChain/valueChainState";
import { valueChainAddress } from "./kindChain";

interface OpenInValueChainLinkProps {
  // The kind or the class the chain is drawn from
  root: ChainCardRef;
}

/** The step into the value chain page with a kind or a class as its root. */
const OpenInValueChainLink: React.FC<OpenInValueChainLinkProps> = ({
  root,
}) => (
  <Link
    component={RouterLink}
    to={valueChainAddress(root)}
    underline="hover"
    variant="body2"
  >
    Open in value chain
  </Link>
);

export default OpenInValueChainLink;
